import { render, staticRenderFns } from "./add-price.vue?vue&type=template&id=509a377c&scoped=true"
import script from "./add-price.vue?vue&type=script&lang=ts"
export * from "./add-price.vue?vue&type=script&lang=ts"
import style0 from "./add-price.vue?vue&type=style&index=0&id=509a377c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a377c",
  null
  
)

export default component.exports